// packages and files
import React, { useContext, useEffect, useRef, useState } from "react";
import { logout } from "hooks/api/logoutApi";
import { AuthContext } from "context/auth/authentication";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, Space, Avatar, Typography, Dropdown, List, Badge, AutoComplete, message } from "antd";

// common files
import { checkUserPermissionFunc } from "components/common/CommonFuntion";
import { getMethod } from "components/common/CommonFuntion";

// custume files
import moment from "moment";

// images and icons
import male from "assets/svg/Male.svg";
import { ImagePaths } from "utils/ImagePath";
import appLogo from "assets/svg/appLogo.svg";
import { CloseOutlined, LockOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
// import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

// api
import { getClockify } from 'pages/home/apihook';
import SwitchUserApi from "hooks/api/SwitchUserApi";
import { EMPLOYEE_RESIGNATION_REQUEST } from 'constants';
import { NOTIFICATION, NOTIFICATION_COUNT } from 'constants';

// css or styles variable
import "../../styles/layout.css"
const styles = {
    sliderAppLogo: {
        width: "13dvw",
        height: "2.5dvw",
        margin: "0.625dvw auto auto 0.425dvw",
        marginBottom: "0dvw !important",
        display: "flex",
        justifyContent: "start",
        alignItems: "center"
    },
    menuDiv: {
        background: "#04B7B1",
        fontSize: "1vw",
        fontFamily: "Urbanist",
        height: "91dvh"
    },
    dropOverLay: {
        width: "9dvw",
        maxHeight: 300,
        overflowY: "auto",
        boxShadow: " 0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    },
    companyTxt: {
        color: "#183433",
        fontSize: "0.95dvw",
        fontWeight: "bold",
        fontFamily: "Urbanist"
    },
    AddressTxt: {
        color: "#616161",
        fontSize: "0.8dvw",
        fontFamily: "Urbanist",
    },
    contentDiv: {
        height: "93%",
        margin: "8px 12px",
        marginTop: 0,
        overflowY: "hidden"
    },
    closeIcon: {
        color: "#616161 !important",
        fontSize: "0.95dvw",
        fontWeight: "bold !important"
    }
}

// destructure the components we gonna use here
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

const NewLayout = ({ children }) => {

    // context / root
    const { logoutauth, loginauth, checkAuth, isAuthenticated } = useContext(AuthContext);
    const rootSubmenuKeys = ["admin", "master", "configuration", "employee", "payroll", "attendance", "assetmanagement", "reports"];
    const menuIconStyle = { width: "1.3dvw", height: "1.3dvw" };

    // states / refs
    const [collapsed, setCollapsed] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState("home");
    const [openKeys, setOpenKeys] = useState([""]);
    const [searchText, setSearchText] = useState("");
    const [isNotifyClk, setIsNotifyClk] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [notifyCount, setNotifyCount] = useState(0);
    const [isShiftOver, setIsShiftOver] = useState(false);
    const [ResignationUrl, setResignationUrl] = useState("employee/offboarding")

    // storage access variables is mentioned here for reducing the used before initialized error
    const shift_details_session = JSON.parse(sessionStorage.getItem("shiftDetails"));
    const [shiftDetails, setShiftDetails] = useState({
        // this state is working with shift_details_session variable in storage access variables sction
        check_in_time: shift_details_session?.check_in_time ? shift_details_session?.check_in_time : null,
        check_out_time: shift_details_session?.check_out_time ? shift_details_session?.check_out_time : null,
        shift_end_time: shift_details_session?.shift_end_time ? shift_details_session?.shift_end_time : null,
        shift_start_time: shift_details_session?.shift_start_time ? shift_details_session?.shift_start_time : null,
        attendance_id: shift_details_session?.attendance_id ? shift_details_session?.attendance_id : null,
    })
    const popupRef = useRef(null);

    // navigate / reassigned variables
    let resigcount = []
    const location = useLocation();
    const navigate = useNavigate();

    // browser storage access variables
    const authtoken = sessionStorage.getItem("token")
    const profile = sessionStorage.getItem("profile")
    const employeeName = sessionStorage.getItem("employee_name")
    const designation = sessionStorage.getItem("designation")
    const modules = JSON.parse(sessionStorage.getItem("modules"));
    const subModule = JSON.parse(sessionStorage.getItem("subModule"));
    const planName = sessionStorage.getItem("planName");
    const is_super_admin = JSON.parse(sessionStorage.getItem("is_super_admin"));
    const is_admin = JSON.parse(sessionStorage.getItem("is_admin"));
    const is_reporting_manager = JSON.parse(sessionStorage.getItem("reportingManager"));
    const is_temp_reporting_manager = JSON.parse(sessionStorage.getItem("tempreportingManager"));

    // useEffect or api call or on mount changes
    // this function is for resignation request count
    const getResigDetail = async () => {
        try {
            const apiData = await getMethod(EMPLOYEE_RESIGNATION_REQUEST);
            if (apiData && apiData.status === "success" && apiData.data) {
                resigcount = apiData.data;

            } else {
                resigcount = []
            }

            if ((resigcount && resigcount?.result?.length > 0) || resigcount?.extras?.active || is_super_admin || is_admin) {
                setResignationUrl("employee/offboarding")
            }
            else {
                setResignationUrl("employee/offboarding/request")
            }
        } catch (error) {
            resigcount = []
        }
    }

    // this function is for fetching the notification
    const getNotificationList = async () => {
        try {
            const authtoken = sessionStorage.getItem("token");
            const url = NOTIFICATION;
            const requestOptions = {
                method: 'GET',
                headers: { 'Authorization': `token ${authtoken}` },
            };

            const response = await fetch(url, requestOptions);
            const apiData = await response.json();

            if (apiData && apiData.status === "success" && apiData.data) {
                setNotificationData([...apiData.data])
                setNotifyCount(0);
            } else {
                setNotificationData([])
            }
        } catch (error) {
            setNotificationData([])
        }
    }

    // notification count
    const getNotificationCount = async () => {
        try {
            const authtoken = sessionStorage.getItem("token");
            const url = NOTIFICATION_COUNT;
            const requestOptions = {
                method: 'GET',
                headers: { 'Authorization': `token ${authtoken}` },
            };

            const response = await fetch(url, requestOptions);
            const apiData = await response.json();
            if (apiData && apiData.status === "success" && apiData.data) {
                setNotifyCount(apiData.data);
            } else {
                setNotifyCount(0);
            }
        } catch (error) {
            setNotifyCount(0);
        }
    }

    // logout functionality
    const handleLogout = async ({ fromTabCls = "" }) => {
        if (isShiftOver && shiftDetails.check_in_time && !shiftDetails.check_out_time && fromTabCls === "") {
            message.warning("Kindly ensure you clock out before logout")
        } else {
            setShiftDetails((prevState) => ({
                ...prevState,
                check_in_time: null,
                check_out_time: null,
                shift_end_time: null,
                shift_start_time: null,
            }))
            try {
                const data = await logout();
                if (data) {
                    if (data.status === "success") {
                        logoutauth();
                        navigate("/");
                        sessionStorage.clear('quoteIndex')
                    } else if (data.status === "fail") {
                        message.warning(data.message);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    // url modification
    function modifyUrl(url) {
        const patterns = [
            // Check for the presence of "/add" and replace it with an empty string
            { pattern: /\/add$/, replacement: "" },
            // Check for the presence of "/edit" and replace it with an empty string
            { pattern: /\/edit$/, replacement: "" },
            // Check for the presence of "/edit" and replace it with an empty string
            { pattern: /\/request$/, replacement: "" },
            // Check for the presence of "/edit" and replace it with an empty string
            { pattern: /\/Submission$/, replacement: "" },
            // Check for the presence of "/updateplan" and replace it with an empty string
            { pattern: /\/updateplan$/, replacement: "" },
            // Check for the presence of "/employeedetails" and replace it with an empty string
            { pattern: /\/employeedetails$/, replacement: "" },
            // Check for the presence of "attendancelog" and remove the back part of the URL
            { pattern: /\/attendancelog\/.*$/, replacement: "/attendancelog" },
            // Check for the presence of "runpayroll" and remove the back part of the URL
            { pattern: /\/runpayroll\/.*$/, replacement: "/runpayroll" },
            // Check for the presence of "approvalinbox" and remove the back part of the URL
            { pattern: /\/approvalinbox\/.*$/, replacement: "/approvalinbox" }
        ];

        patterns.forEach(({ pattern, replacement }) => {
            url = url.replace(pattern, replacement);
        });

        return url;
    }

    // Set up event listener to track window resizing
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            handleCloseNotification();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // this useEffect call is for intimating the user from clockin before using any kind of moudle
    useEffect(() => {
        if (!shiftDetails.shift_start_time || !shiftDetails.shift_end_time) {
            return;
        }
        const startTime = new Date(shiftDetails.shift_start_time);
        const endTime = new Date(shiftDetails.shift_end_time);
        if (endTime < startTime) {
            endTime.setDate(endTime.getDate() + 1);
        }
        const calculateTimeLeft = () => {
            const now = new Date();
            const timeDiff = endTime.getTime() - now.getTime();
            return Math.max(timeDiff, 0);
        };
        const timer = setInterval(() => {
            const remainingTime = calculateTimeLeft();
            setIsShiftOver(remainingTime === 0);
            if (remainingTime === 0) {
                clearInterval(timer);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [shiftDetails.shift_start_time, shiftDetails.shift_end_time]);

    useEffect(() => {
        getResigDetail()
        getNotificationList()
        getNotificationCount()
    }, [])

    useEffect(() => {
        getNotificationCount()
    }, [selectedMenuItem])

    // ##------SIDEBAR FUNCTIONALITYS----##

    useEffect(() => {
        if (authtoken
            // && (shiftDetails.check_in_time || shiftDetails.check_out_time)
        ) {
            // Extract the current route or URL path and set the selected menu item accordingly
            const currentPath = location.pathname.replace(/^\/+/g, "");
            const activeSubMenu = currentPath.split("/")[0];
            // Helps in selecting the parent side menu 
            let selectedPath = modifyUrl(currentPath);
            setSelectedMenuItem(selectedPath);
            setOpenKeys([activeSubMenu.toString()]);
        }
    }, [location]);

    // Function to handle screen resizing
    const handleResize = () => {
        if (window.innerWidth <= 768) {
            setCollapsed(true); // Collapse the sidebar if width is 768px or smaller
        } else {
            setCollapsed(false); // Expand the sidebar if width is greater than 768px
        }
    };

    // functions for the sidebar child data layout
    const handleChildData = (data) => {
        if (data) {
            // data from home;
            const { check_in, check_out, shift_end_time, shift_start_time, attendance_id } = data;
            const objSession = { check_in_time: check_in, check_out_time: check_out, shift_end_time, shift_start_time, attendance_id };

            setShiftDetails((prevState) => ({
                ...prevState,
                ...objSession
            }));

            sessionStorage.setItem("shiftDetails", JSON.stringify(objSession));
        }
    };

    // Check if the current time is within shift start and end time
    const isWithinShift = () => {
        const shiftStartTime = new Date(shiftDetails.shift_start_time);
        const shiftEndTime = new Date(shiftDetails.shift_end_time);
        const currentTime = new Date();
        return currentTime >= shiftStartTime && currentTime <= shiftEndTime;
    };

    // function for selecting the menu and naviagtes to it
    const handleMenuSelect = ({ key }) => {
        if (authtoken &&
            ((!shiftDetails.shift_start_time && !shiftDetails.shift_end_time)
                || (shiftDetails.check_in_time || shiftDetails.check_out_time) || !isWithinShift()
            )) {
            setSelectedMenuItem(key);
            navigate(key);
        } else {
            message.error("You must clock in to access any forms. Please clock in through the Home");
        }
    };

    // at a time only one menu gets open function
    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
        setSearchText("");
    };

    // toggle the sidebar as well as menu items
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    // Helper function to create menu items
    const createMenuItem = (key, label, icon, subMenuPermissions = []) => {
        let objArr = {
            key: key,
            label: label,
            icon: <img src={ImagePaths[icon].default} style={menuIconStyle} alt={label} />,
            subMenu: [],
        };

        // Add submenus based on permission
        if (subMenuPermissions.length > 0) {
            subMenuPermissions.forEach(permission => {
                if (
                    (permission.module === "" && permission.subModule === "") || // Allow if module and subModule are empty
                    checkUserPermissionFunc(permission.module, permission.subModule, "SubMenu").permission
                ) {
                    objArr.subMenu.push({ key: permission.key, label: permission.label });
                }
            });
        }

        return objArr;
    };

    // Menu Configuration (define permissions for submenus)
    const employerMenuItems = [];

    // Add Home item
    employerMenuItems.push({
        key: 'home',
        label: 'Home',
        icon: <img src={ImagePaths.home.default} style={menuIconStyle} alt="home" />
    });

    // Add Admin Menu
    if (checkUserPermissionFunc("administrator", null, "Menu").permission) {
        const adminSubMenu = [
            { module: "administrator", subModule: "Organization", key: 'admin/companyprofile', label: 'Organization' },
            { module: "administrator", subModule: "User Group", key: 'admin/usergroup', label: 'User Group' },
            { module: "administrator", subModule: "User Permission", key: 'admin/userpermission', label: 'User Permission' },
            { module: "administrator", subModule: "Notice Board", key: 'admin/noticeboard', label: 'Notice Board' },
            { module: "administrator", subModule: "Password Policy", key: 'admin/passwordpolicy', label: 'Password Policy' },
            { module: "administrator", subModule: "Organization Documents", key: 'admin/organizationdocuments', label: 'Organization Documents' }
        ];
        employerMenuItems.push(createMenuItem('admin', 'Admin', 'admin', adminSubMenu));
    }

    // Add Master Menu
    if (checkUserPermissionFunc("master", null, "Menu").permission) {
        const masterSubMenu = [
            { module: "master", subModule: "Employee Type", key: 'master/employeetype', label: 'Employee Type' },
            { module: "master", subModule: "Department", key: 'master/department', label: 'Department' },
            { module: "master", subModule: "Designation", key: 'master/designation', label: 'Designation' },
            { module: "master", subModule: "Leave Type", key: 'master/leavetype', label: 'Leave and Remote Setup' },
            { module: "master", subModule: "Employee Group", key: 'master/employeegroup', label: 'Employee Group' },
            { module: "master", subModule: "Reimbursements Type", key: 'master/reimbursementstype', label: 'Reimbursement Type' },
            { module: "master", subModule: "Asset Type", key: 'master/assettype', label: 'Asset Type' },
            { module: "master", subModule: "Asset Category", key: 'master/assetcategory', label: 'Asset Category' },
            { module: "master", subModule: "Asset Sub Category", key: 'master/assetsubcategory', label: 'Asset Sub Category' },
            { module: "master", subModule: "Letter Type", key: 'master/lettertype', label: 'Letter Type' },
            { module: "master", subModule: "Letter Template", key: 'master/lettertemplate', label: 'Letter Template' }
        ];
        employerMenuItems.push(createMenuItem('master', 'Master', 'master', masterSubMenu));
    }

    // Add Configuration Menu
    if (checkUserPermissionFunc("configuration", null, "Menu").permission) {
        const configSubMenu = [
            { module: "configuration", subModule: "Shift Configuration", key: 'configuration/shiftconfiguration', label: 'Shift Configuration' },
            { module: "configuration", subModule: "Holiday", key: 'configuration/holiday', label: 'Holiday Setup' },
            { module: "configuration", subModule: "Week off", key: 'configuration/weekoff', label: 'Weekoff' },
            { module: "configuration", subModule: "Payroll Period", key: 'configuration/payrollperiod', label: 'Payroll Period' },
            { module: "configuration", subModule: "Subordinate", key: 'configuration/subordinate', label: 'Subordinate Setup' },
            { module: "configuration", subModule: "Custom Configuration", key: 'configuration/customconfiguration', label: 'Custom Configuration' },
            { module: "configuration", subModule: "Salary Component", key: 'configuration/salarycomponent', label: 'Salary Component' },
            { module: "configuration", subModule: "Salary Template", key: 'configuration/salarytemplate', label: 'Salary Template' }
        ];
        employerMenuItems.push(createMenuItem('configuration', 'Configuration', 'configuration', configSubMenu));
    }

    // Add Employee Menu
    // This array always has the unrestricted items
    let employeeSubMenu = [
        { module: "", subModule: "", key: "employee/employees", label: 'Employees' },
        { module: "", subModule: "", key: "employee/leaverequest", label: 'Leave and Remote Request' },
        { module: "", subModule: "", key: "employee/reimbursementsrequest", label: 'Reimbursement Request' },
        { module: "", subModule: "", key: "employee/advancesalaryrequest", label: 'Advance Salary Request' },
        { module: "", subModule: "", key: "employee/subordinates", label: 'Subordinates' },
        { module: "", subModule: "", key: ResignationUrl, label: 'Resignation' },
    ];

    // Conditionally add restricted submenu items
    const isEmployeeMenuAllowed = checkUserPermissionFunc("employee", null, "Menu").permission;
    if (isEmployeeMenuAllowed) {
        employeeSubMenu.push(
            { module: "employee", subModule: "Approval Inbox", key: "employee/approvalinbox", label: 'Approval Inbox' },
            { module: "employee", subModule: "TDS Declaration", key: "employee/tdsdeclaration", label: 'TDS Declaration Form' },
            { module: "employee", subModule: "Employee Onboarding", key: "employee/employeeonboarding", label: 'Employee Onboarding' },
            { module: "employee", subModule: "Intern Onboarding", key: "employee/internonboarding", label: 'Intern Onboarding' }
        );
        // Only push this if the user is a reporting manager
        if (is_reporting_manager || is_temp_reporting_manager) {
            employeeSubMenu.push({
                module: "employee",
                subModule: "Transfer Reporting Manager",
                key: "employee/transferreportingmanager",
                label: "Transfer Reporting Manager"
            });
        }
        // Always push this
        employeeSubMenu.push({
            module: "employee",
            subModule: "Transfer Inbox",
            key: "employee/transferinbox",
            label: "Transfer Inbox"
        });
    }

    // Push main menu item regardless of permission
    employerMenuItems.push(createMenuItem('employee', 'Employee', 'employee', employeeSubMenu));

    // Add Payroll Menu
    if (checkUserPermissionFunc("payroll", null, "Menu").permission) {
        let payrollSubMenu = [
            { module: "payroll", subModule: "Run Payroll", key: "payroll/runpayroll", label: 'Run Payroll' },
            { module: "payroll", subModule: "Payroll", key: "payroll/payroll", label: 'Payroll' },
            { module: "payroll", subModule: "payslips", key: "payroll/payslips", label: 'Payslip' },
            { module: "", subModule: "", key: "payroll/salarycalculator", label: 'Salary Calculator' }
        ];
        employerMenuItems.push(createMenuItem('payroll', 'Payroll', 'payroll', payrollSubMenu));
    }

    // Add Attendance Menu
    let attendanceSubMenu = [
        { module: "", subModule: "", key: "attendance/dayattendance", label: 'Day-wise Attendance' },
        { module: "", subModule: "", key: "attendance/attendancelog", label: 'Attendance Log' }
    ];
    employerMenuItems.push(createMenuItem('attendance', 'Attendance', 'attendance', attendanceSubMenu));

    // Add Asset management Menu
    if (checkUserPermissionFunc("Asset Management", null, "Menu").permission) {
        let assetManagementSubmenu = [
            { module: "Asset Management", subModule: "Asset Registry", key: "assetmanagement/assetregistry", label: 'Asset Registry' },
            { module: "Asset Management", subModule: "Asset Employee Audit", key: "assetmanagement/assetemployeeaudit", label: 'Asset Employee Audit' },
        ];
        employerMenuItems.push(createMenuItem('assetmanagement', 'Asset Management', 'assetManagement', assetManagementSubmenu));
    }

    // Add Roaster Menu
    if (checkUserPermissionFunc("Roster", null, "Menu").permission) {
        employerMenuItems.push(
            { key: 'roster', label: 'Roster', icon: <img src={ImagePaths.rosterIcon.default} style={menuIconStyle} alt="roster" /> });
    }

    // Add Report Menu
    if (checkUserPermissionFunc("reports", null, "Menu").permission) {
        const reportSubMenu = [
            { module: "reports", subModule: "Day wise Attendance", key: 'reports/daywiseattendance', label: 'Day-wise Attendance' },
            { module: "reports", subModule: "Month Wise Attendance", key: 'reports/monthwiseattendance', label: 'Month Wise Attendance' },
            { module: "reports", subModule: "Salary Process Bank", key: 'reports/salaryprocessbank', label: 'Salary Process Bank' },
            { module: "reports", subModule: "Employee Salary Summary", key: 'reports/employeesalarysummary', label: 'Employee Salary Summary' },
            { module: "reports", subModule: "Payroll Detailed Summary", key: 'reports/payrolldetailedsummary', label: 'Payroll Detailed Summary' },
            { module: "reports", subModule: "Employee ESI Statement", key: 'reports/employeeesistatement', label: 'Employee ESI Statement' },
            { module: "reports", subModule: "Employee PF Statement", key: 'reports/employeepfstatement', label: 'Employee PF Statement' },
            { module: "reports", subModule: "Muster Roll", key: 'reports/musterroll', label: 'Muster Roll' },
            { module: "reports", subModule: "Employee Earning Deduction", key: 'reports/employeeearningdeduction', label: 'Employee Credits & Debits' },
            { module: "reports", subModule: "Attendance Correction", key: 'reports/attendancecorrection', label: 'Attendance Correction' },
            { module: "reports", subModule: "Subordinates", key: 'reports/subordinates', label: 'Subordinates Report' },
            { module: "reports", subModule: "Roster Report", key: 'reports/rosterreport', label: 'Roster Report' },
            { module: "reports", subModule: "Leave Permission Report", key: 'reports/leavepermissionreport', label: 'Leave Permission Report' }
        ];
        employerMenuItems.push(createMenuItem('reports', 'Reports', 'reports', reportSubMenu));
    }

    // Add Data Migration Menu
    if (is_super_admin) {
        const migrateSubMenu = [
            { module: "", subModule: "", key: "datamigration/employeemigration", label: 'Employee Migration' }
        ]
        employerMenuItems.push(createMenuItem('datamigration', 'Data Migration', 'assetManagement', migrateSubMenu));
    }

    // Add Plans Menu
    if (is_super_admin) {
        employerMenuItems.push({
            key: 'myplans',
            label: 'My Plans',
            icon: <img src={ImagePaths.myplan.default} style={menuIconStyle} alt="myplans" />
        });
    }

    // ##------HEADER FUNCTIONALITYS-------##

    // flatten menu option for quick search
    const flattenMenuItems = () => {
        let flattenedItems = [];
        employerMenuItems.forEach(item => {
            if (item.subMenu) {
                flattenedItems.push(...item.subMenu.map(subItem => ({ key: subItem.key, label: subItem.label })));
            } else {
                flattenedItems.push({ key: item.key, label: item.label });
            }
        });
        return flattenedItems?.length > 0 ? flattenedItems : [];
    };

    const flattenedList = flattenMenuItems();

    // function for handle the onclick in quick search/navigate
    const handleOnSelect = (value) => {
        if (value && authtoken &&
            ((!shiftDetails.shift_start_time && !shiftDetails.shift_end_time) ||
                (shiftDetails.check_in_time || shiftDetails.check_out_time) || !isWithinShift())) {
            if (rootSubmenuKeys.indexOf(value) === -1) {
                setSelectedMenuItem(value);
                navigate(value);
            } else {
                setOpenKeys(value ? [value] : []);
            }
        } else {
            message.error("You must clock in to access any forms. Please clock in through the Home");
        }
    }

    // cleaned modules for submenu
    const cleanedModules = subModule?.map(module => {
        // Clean the main module name
        let cleanedModuleName = module?.module_name?.replace(/_/g, "");
        if (cleanedModuleName === "administrator") {
            cleanedModuleName = "admin";
        }

        // Clean the submodule names
        const cleanedSubModules = {};
        if (module?.sub_module_list && Object.keys(module?.sub_module_list)?.length > 0) {
            Object.keys(module?.sub_module_list)?.forEach(subModule => {
                // Clean submodule name and add it as module/submodule
                let cleanedSubModule = `${cleanedModuleName}/${subModule?.replace(/_/g, "")}`;
                if (subModule === "offboarding") {
                    if ((resigcount && resigcount?.result?.length > 0) ||
                        resigcount?.extras?.active ||
                        is_super_admin || is_admin) {
                        cleanedSubModule = `${cleanedModuleName}/${subModule?.replace(/_/g, "")}`;
                    }
                    else {
                        cleanedSubModule = `${cleanedModuleName}/${subModule?.replace(/_/g, "")}/request`;
                    }
                }
                cleanedSubModules[cleanedSubModule] = module?.sub_module_list[subModule];
            });
        }

        // Return the cleaned module and its cleaned submodules
        return {
            ...module,
            module_name: cleanedModuleName,
            sub_module_list: cleanedSubModules
        };
    });

    // closing the overlay for function
    const handleCloseNotification = () => {
        setIsNotifyClk(false);
    };

    // fucntion for rendering menu and cleaned the extra codes
    const renderMenu = () => {
        return employerMenuItems.map((menuItem) => {
            // Find the corresponding module in cleanedModules by module_name
            const matchedModule = cleanedModules?.find(
                (module) => module?.module_name === menuItem.key
            );
            const isModuleSubscribed = matchedModule?.is_subscribed;
            const subModuleList = matchedModule?.sub_module_list || {};

            return menuItem.subMenu ? (
                <SubMenu
                    key={menuItem.key}
                    title={
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: !isModuleSubscribed ? "space-between" : "start",
                            }}
                        >
                            <label>{menuItem.label}</label>
                            {!isModuleSubscribed && (
                                <div style={{ fontSize: "0.75vw", color: "white" }}>
                                    <LockOutlined />
                                </div>
                            )}
                        </div>
                    }
                    icon={menuItem.icon}
                >
                    {menuItem.subMenu.map((subMenuItem) => {
                        const isSubModuleSubscribed = subModuleList[subMenuItem.key];
                        return (
                            <Menu.Item
                                style={{
                                    paddingLeft: !isSubModuleSubscribed ? "25px" : window.innerWidth <= 768 ? "30px" : "50px",
                                }}
                                key={
                                    isSubModuleSubscribed
                                        ? subMenuItem.key
                                        : `${subMenuItem.key}/subscribenow`
                                }
                                icon={subMenuItem.icon}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: !isModuleSubscribed ? "space-between" : "start",
                                    }}
                                >
                                    {!isSubModuleSubscribed && (
                                        <div
                                            style={{
                                                fontSize: "0.75vw",
                                                paddingRight: "11px",
                                                color: "white",
                                            }}
                                        >
                                            <LockOutlined />
                                        </div>
                                    )}
                                    <label>{subMenuItem.label}</label>
                                </div>
                            </Menu.Item>
                        );
                    })}
                </SubMenu>
            ) : (
                <Menu.Item
                    key={isModuleSubscribed ? menuItem.key : `${menuItem.key}/subscribenow`}
                    icon={menuItem.icon}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: !isModuleSubscribed ? "space-between" : "start",
                        }}
                    >
                        <label>{menuItem.label}</label>
                        {!isModuleSubscribed && (
                            <div style={{ fontSize: "0.75vw", color: "white" }}>
                                <LockOutlined />
                            </div>
                        )}
                    </div>
                </Menu.Item>
            );
        });
    };

    // dropdown item
    const items = [
        {
            key: "1",
            label: (
                <div
                    className="empApproveTxt"
                    style={{ margin: '-0.5dvw', padding: '0.5dvw' }}
                    onClick={() => navigate('/employeeProfile')}>
                    Profile
                </div>),
        },
        {
            key: "2",
            label: (
                <div
                    className="empApproveTxt"
                    style={{ margin: '-0.5dvw', padding: '0.5dvw' }}
                    onClick={handleLogout}>
                    Log Out
                </div>),
        }];

    return (
        // layout
        <>
            <Layout>
                {/* Sidebar */}
                <Sider
                    width={"18dvw"}
                    className="h-screen fixed overflow-y-hidden overflow-x-hidden"
                    style={{ background: "#04B7B1" }}
                    collapsed={collapsed}
                    onCollapse={toggleCollapsed}
                >
                    {/* App Logo */}
                    <div className=" flex gap-2 items-center">
                        <img src={appLogo} style={styles.sliderAppLogo} alt="App Logo" />
                        {/* {!collapsed ? <img src={appLogo} style={styles.sliderAppLogo} alt="App Logo" /> : ""}
                        <button onClick={toggleCollapsed} className=" px-3 text-white text-xl">
                            {!collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        </button> */}
                    </div>
                    <hr style={{ background: "#ffffff", margin: "6px 0px" }} />

                    {/* Navigation Menu */}
                    <Menu
                        defaultSelectedKeys={['home']}
                        theme="dark"
                        mode="inline"
                        onSelect={handleMenuSelect}
                        rootClassName="overflow-y-auto overflow-x-hidden"
                        selectedKeys={[selectedMenuItem]}
                        openKeys={openKeys}
                        onOpenChange={onOpenChange}
                        style={styles.menuDiv}
                        className="text-white w-full"
                    >
                        {isAuthenticated && renderMenu()}
                    </Menu>
                </Sider>

                {/* Main Layout */}
                <Layout>
                    {/* Header */}
                    <Header
                        style={{
                            padding: "0 15px",
                            background: "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                        }}
                    >
                        {/* Quick Search */}
                        <div className="custom-auto-complete-container">
                            <img
                                src={ImagePaths.search.default}
                                alt="search"
                                style={{ ...styles.menuIconStyle, margin: "0.1875dvw" }}
                            />
                            <AutoComplete
                                className="custom-auto-complete"
                                style={{ width: "100%" }}
                                allowClear={true}
                                value={searchText}
                                options={flattenedList.map((item) => ({
                                    value: item.key,
                                    label: item.label,
                                }))}
                                onSelect={handleOnSelect}
                                onChange={(value, option) =>
                                    setSearchText(option?.label ? option?.label : value)
                                }
                                filterOption={(inputValue, option) =>
                                    option.label.toUpperCase().includes(inputValue.toUpperCase())
                                }
                                notFoundContent={
                                    <div style={{ textAlign: "center", fontSize: "0.95dvw" }}>
                                        No data found
                                    </div>
                                }
                                placeholder="Quick Search"
                                onKeyDown={(e) => {
                                    if (!/[a-zA-Z\s]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </div>

                        {/* Vertical Divider */}
                        <div className="hidden sm:block w-px h-8 bg-gray-300"></div>

                        <Space>
                            {/* User Info */}
                            <div className="flex items-center gap-3">
                                <div className="ml-4 flex flex-col items-end cursor-pointer" onClick={() => navigate("/employeeprofile")}>
                                    <Typography style={styles.companyTxt}>{employeeName || ""}</Typography>
                                    <Typography style={styles.AddressTxt}>
                                        {(designation && designation !== "null" && designation !== "undefined") ? designation : ""}
                                    </Typography>
                                </div>

                                {/* User Profile */}
                                <Avatar
                                    src={profile || male}
                                    size="large"
                                    style={styles.userDp}
                                    className=" cursor-pointer scale-125 hover:shadow-lg"
                                    onClick={() => navigate("/employeeprofile")}
                                />

                                {/* Notifications */}
                                <div className="relative">
                                    <Badge
                                        className="mx-3 absolute -top-2"
                                        count={notifyCount || ""}
                                    ></Badge>
                                    <img
                                        src={ImagePaths.bellIcon.default}
                                        className="layoutIcon cursor-pointer transition-transform duration-300 hover:rotate-[25deg] hover:scale-110"
                                        alt="notification"
                                        onClick={() => {
                                            setIsNotifyClk(true);
                                            getNotificationList();
                                        }}
                                    />
                                </div>
                                <div ref={popupRef} className={`list-container ${isNotifyClk ? "visible" : ""}`}>
                                    <div className="list-header">
                                        Notification
                                        <CloseOutlined
                                            style={styles.closeIcon}
                                            onClick={handleCloseNotification}
                                        />
                                    </div>
                                    <div className="scrollable-container">
                                        <List
                                            itemLayout="horizontal"
                                            dataSource={notificationData}
                                            renderItem={(item, index) => (
                                                <List.Item key={index}>
                                                    <List.Item.Meta
                                                        className={`custom-list-item-meta cursor-pointer p-2 rounded-md ${!item.is_opened ? 'bg-[#04b7b151]' : 'bg-white'}`}
                                                        onClick={() => {
                                                            const { notification_action, notification_type, type_id } = item;

                                                            if (notification_action === 'request') {
                                                                navigate('employee/approvalinbox', { state: { notification_type, type_id } });
                                                            } else if (['approved', 'rejected', 'cancelled'].includes(notification_action)) {
                                                                const routes = {
                                                                    Leave: 'employee/leaverequest',
                                                                    Advance: 'employee/advancesalaryrequest',
                                                                    Reimbursement: 'employee/reimbursementsrequest',
                                                                    Resignation: '/employee/offboarding',
                                                                };

                                                                if (routes[notification_type]) {
                                                                    navigate(routes[notification_type], { state: { notification_type, type_id } });
                                                                }
                                                            } else if (notification_action === null) {
                                                                return message.warning("Something went wrong!");
                                                            }

                                                            setIsNotifyClk(false);
                                                        }}
                                                        avatar={
                                                            <img
                                                                src={
                                                                    item?.status === "approved"
                                                                        ? ImagePaths.notifyApprove.default
                                                                        : ImagePaths.notifyReject.default
                                                                }
                                                                className="notifyIcon"
                                                                alt="Approved"
                                                            />
                                                        }
                                                        title={
                                                            <p className="notifyTxt cursor-pointer hover:text-[#04b7b1]">
                                                                {item?.title ? item?.title : "-"}
                                                            </p>
                                                        }
                                                        description={
                                                            <div>
                                                                <p className="userPermission-checkbox-subTlt notifyTxt">
                                                                    {item?.message ? item?.message : "-"}
                                                                </p>
                                                                <p className="userPermission-checkbox-subTlt text-right notifyTxt">
                                                                    {item?.time
                                                                        ? moment(
                                                                            item?.time,
                                                                            "YYYY-MM-DD HH:mm:ss"
                                                                        ).format("DD-MM-YYYY hh:mm A")
                                                                        : ""}
                                                                </p>
                                                            </div>
                                                        }
                                                    />
                                                </List.Item>
                                            )}
                                        />
                                    </div>
                                </div>

                                {/* Logout Dropdown */}
                                <Dropdown
                                    menu={{ items }}
                                    trigger={["click"]}
                                    placement="bottomLeft"
                                    overlayStyle={styles.dropOverLay}
                                >
                                    <img
                                        src={ImagePaths.logoutIcon.default}
                                        className="layoutIcon"
                                        alt="Logout"
                                    />
                                </Dropdown>
                            </div>
                        </Space>
                    </Header>

                    {/* Content Area */}
                    <Content
                        style={{
                            margin: "0 10px"
                        }}
                    >
                        {children}
                        <Outlet context={{ handleChildData }} />
                    </Content>
                </Layout>
            </Layout>
        </>
    );
}

export default NewLayout;